export class TagTracking{
	init(){

        $('a[download]').on('click', function(){
            let event_label = $(this).attr('data-label');
            try{
                gtag('event', 'click', {'event_category': 'plik', 'event_action': 'pobierz pdf', 'event_label' : event_label});
            } catch (error) {
                console.error(error);
            }
        })

        $('a[data-target="#videoModal"]').on('click', function(){
            let event_label = $(this).find('span').text();
            try{
                gtag('event', 'click', {'event_category': 'videoModal', 'event_action': 'klik', 'event_label' : event_label});
            } catch (error) {
                console.error(error);
            }
        })

        $('.features-list#accordionContact_6 .features-list__item > span').on('click', function(){
            let event_label = $(this).attr('data-label');
            try{
                gtag('event', 'click', {'event_category': 'Opis zastosowania', 'event_label' : event_label});
            } catch (error) {
                console.error(error);
            }
        })

        $('.features-list#accordionContact_7 .features-list__item > span').on('click', function () {
            let area = getAreaLabel($(this).attr('data-area'));
            let market = $(this).attr('data-label');
            try {
                if(area && market){
                    let label = area + " - " + market;
                    gtag('event', 'click', {'event_category': 'Gdzie kupić', 'event_label' : label});
                }
            } catch (error) {
                console.error(error)
            }

        })
        $('.features-list#accordionContact_7 a.mail').click(function(){
            let event_category = getAreaLabel($(this).attr('data-area'))
            let event_label = $(this).attr('data-label');
            if (event_label && typeof(event_label) == 'string'){
                event_label = event_label.toUpperCase();
            }
            if (event_label && event_category){
                gtag('event', 'Adres e-mail', {'event_category': event_category, 'event_label' : event_label});
            }
        })

        $('.features-list#accordionContact_7 a.show_number').click(function () {
            let event_category = getAreaLabel($(this).attr('data-area'))
            let event_label = $(this).attr('data-label');

            if (event_label && typeof(event_label) == 'string'){
                event_label = event_label.toUpperCase();
            }
            if (event_label && event_category){
                gtag('event', 'Pokaż numer', {'event_category': event_category, 'event_label' : event_label});
            }
        })

        $('.features-list#accordionContact_7 a.show_address').click(function () {
            let event_category = getAreaLabel($(this).attr('data-area'))
            let event_label = $(this).attr('data-label');

            if (event_label && typeof(event_label) == 'string'){
                event_label = event_label.toUpperCase();
            }
            if (event_label && event_category){
                gtag('event', 'Pokaż adres', {'event_category': event_category, 'event_label' : event_label});
            }
        });

        var getAreaLabel = function (area_id) {
            switch (area_id) {
                case 'area1':
                    return "Region Szczecin";
                case 'area2':
                    return "Region Gdańsk";
                case 'area3':
                    return "Region Olsztyn";
                case 'area4':
                    return "Region Toruń";
                case 'area5':
                    return "Region Poznań";
                case 'area6':
                    return "Region Warszawa";
                case 'area7':
                    return "Region Białystok";
                case 'area8':
                    return "Region Wrocław"
                case 'area9':
                    return "Region Łódź";
                case 'area10':
                    return "Region Katowice";
                case 'area11':
                    return "Region Kraków";
                case 'area12':
                    return "Region Lublin / Rzeszów";
                default:
                    return null;
            }
        }
    }
}